<div class="points-container">
  <div class="d-flex align-items-center justify-content-between">
    <div class="back-item">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.97508 4.94165L2.91675 9.99998L7.97508 15.0583" stroke="white" stroke-width="1.5"
          stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M17.0834 10H3.05835" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>

      <h2>
        Point And Achievements
      </h2>
    </div>
    <app-button label="Submit external event" [minWidth]="'14.813rem'"
      (clicked)="openExternalEventDialog()"></app-button>
  </div>

  <div class="point-display">
    <div class="pdp-point cnt-1">
      <div class="img-container">
        <img src="assets/images/user/Coin.gif" alt="">
      </div>
      <div class="points-details">
        <h2>{{data?.totalPoints || '0'}}</h2>
        <p>PDP Earned</p>
      </div>
    </div>

    <div class="pdp-point cnt-2">
      <div class="img-container">
        <img [src]="data?.badgeIcon || 'assets/images/user/image.png'" alt="" />

      </div>
      <div class="explore-details">
        <h2>{{data?.badgeName || '-'}}</h2>
        <p>
          {{data?.motivationalMessage
          || '-'}}</p>
      </div>
    </div>

    <div class="pdp-point-details">
      <div class="top-items">
        <p>Last 7 Days</p>
        <button>100</button>
      </div>

      <div class="bottom-item">
        <div>
          <h3>{{data?.last7DaysExtra || '0'}}</h3>
          <p>Extra</p>
        </div>

        <div>
          <h3>{{data?.last7DaysWorkExp || '0'}}</h3>
          <p>Work Exp.</p>
        </div>

        <div>
          <h3>{{data?.last7DaysEventAttempts || '0'}}</h3>
          <p>Event Attempt</p>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="table-card">
      <app-table [columns]="columns" [data]="tableData" [actionTemplate]="actionButtonsTemplate" [loading]="loading"
        (rowClick)="onView($event)">
      </app-table>
    </div>
  </div>
</div>